import { procurementAPI } from "../../axios";

export const actions = {

    //RfqSupplierOffer
    GetSingleRSO(context, data){
        return procurementAPI.get(`RfqSupplierOffer/${data}`);
    },
    GetRSO(context, data){
        return procurementAPI.get(`RfqSupplierOffer/RfqSupplier/${data}`);
    },
    GetRSOWinner(context, data){
        return procurementAPI.get(`RfqSupplierOffer/Winner/${data}`);
    },
    UpdateRSO(context, data){
        return procurementAPI.put(`RfqSupplierOffer/${data.id}`, data);
    },
    MarkWinnerRSO(context, data){
        return procurementAPI.put(`RfqSupplierOffer/Winner/${data.id}?IsWinner=${data.IsWinner}`);
    },
    DeleteRSO(context, data){
        return procurementAPI.delete(`RfqSupplierOffer/${data}`);
    },
    CreateRSO(context, data){
        return procurementAPI.post(`RfqSupplierOffer/Create`, data);
    },
    AddOfferToItem(context, data){
        return procurementAPI.post(`RfqSupplierOffer/Add/ToItem?id=${data}`);
    },
    AddAllOfferToItem(context, data){
        return procurementAPI.post(`RfqSupplierOffer/Add/ToItem/Multiple`, data);
    },
    ChangeOfferStatus(context, data){
        return procurementAPI.put(`RfqSupplierOffer/Status/${data.id}/${data.status}`);
    },
    UpdateQuantity(context, data){
        return procurementAPI.put(`RfqSupplierOffer/Quantity/${data.id}/${data.quantity}`);
    }
}